import React from "react";

const Sidebar = (props) => {
  return <div className="side-bar">{props.options()}</div>;
};
export default Sidebar;
